/*
 * OPENRARE App dark palette preview.
 * This file intentionally changes colors only. Removing its two imports
 * restores the previous yellow/light theme without touching page layout.
 */

:root {
  color-scheme: dark;
  color: #f5f7f7;
  background: #040509;
}

html,
body,
#app {
  background: #040509;
}

.site-shell {
  --color-accent: #f05a20 !important;
  --color-accent-soft: #32201a !important;
  --color-ink: #f5f7f7 !important;
  --color-paper: #040509 !important;
  --color-muted: #98a5aa !important;
  color: #f5f7f7;
  background: #040509;
}

.app-header {
  border-bottom-color: rgb(38 59 62 / 66%);
  background: rgb(4 5 9 / 90%);
  color: #f5f7f7;
}

.app-header__brand,
.app-header__link {
  color: #f5f7f7;
}

.app-header__brand-accent {
  color: #f05a20;
}

.language-picker__button:hover {
  background: #142225;
}

.theme-toggle__button {
  color: #f5f7f7;
}

.theme-toggle__button:hover {
  background: #142225;
}

.language-picker__button img {
  filter: invert(1) grayscale(1) brightness(1.35);
}

.language-picker__menu {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 0 14px 40px rgb(0 0 0 / 42%);
}

.language-picker__menu button {
  color: #f5f7f7;
  -webkit-text-fill-color: #f5f7f7;
}

.language-picker__menu button:hover,
.language-picker__menu button.active {
  background: #283235;
}

.hero-section {
  background-color: #040509;
}

.hero-section::after {
  background:
    linear-gradient(180deg, transparent 0 60%, rgb(4 5 9 / 58%) 82%, #040509 100%),
    radial-gradient(circle at 50% 43%, transparent 0 28%, rgb(4 5 9 / 18%) 58%, rgb(4 5 9 / 62%) 100%);
}

.hero-section__glow {
  background: rgb(240 90 32 / 18%);
}

.hero-section__cta {
  background: #f05a20;
  box-shadow: none;
  color: #ffffff;
}

.hero-section__cta:hover {
  box-shadow: none;
}

.floating-play-cta,
.floating-play-cta:active {
  background: #f05a20;
  color: #ffffff;
}

.page-section,
.stores-section,
.transport-section {
  background: #040509;
}

.section-title__eyebrow {
  color: #7f8d92;
}

.section-title h2,
.store-card__details strong,
.process-card h3 {
  color: #f5f7f7;
}

.section-title__scribble {
  color: #f05a20;
}

/* 只作用在笔刷图本身。若写在外层 .section-title__watermark 上，
   brightness(0) 会把内部的高光层一起压成黑再重新染成同一种橙，
   高光就退化成「整体闪一下」而不是一道光扫过。 */
.section-title__watermark-art {
  opacity: 0.58;
  filter: brightness(0) saturate(100%) invert(41%) sepia(99%) saturate(2655%) hue-rotate(352deg) brightness(98%) contrast(91%);
}

.section-intro,
.store-card__details a,
.process-card p,
.transport-section__copy {
  color: #98a5aa;
}

.store-card__main-wrap,
.thumbnail-marquee button {
  background: #0b1519;
}

.thumbnail-marquee button {
  border-color: #263b3e;
}

.thumbnail-marquee button:hover,
.thumbnail-marquee button.active {
  border-color: #f05a20;
}

.store-card__pin {
  color: #f05a20;
}

.process-section {
  background: #0b1519;
}

.process-section::before {
  background: linear-gradient(180deg, rgb(4 5 9 / 0%), #0b1519);
}

.process-card {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 0 6px 20px rgb(0 0 0 / 20%);
}

.process-card__number {
  background: #f05a20;
  color: #ffffff;
}

.protection-section {
  background: #040509;
}

.protection-section::before {
  background: linear-gradient(180deg, #0b1519, rgb(4 5 9 / 0%));
  opacity: 1;
}

.protection-section__lead strong,
.protection-card h3 {
  color: #f5f7f7;
}

.protection-section__lead p,
.protection-card p {
  color: #98a5aa;
}

.protection-card {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 0 10px 28px rgb(0 0 0 / 22%);
}

.protection-card:hover {
  border-color: rgb(240 90 32 / 68%);
}

.transport-section__media {
  box-shadow: 0 22px 50px rgb(0 0 0 / 38%);
}

.contact-section {
  background:
    radial-gradient(circle at 12% 12%, rgb(240 90 32 / 12%), transparent 30%),
    #040509;
}

.contact-section__intro,
.contact-card > p,
.contact-link small {
  color: #98a5aa;
}

.contact-card {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 0 12px 30px rgb(0 0 0 / 22%);
}

.contact-card:hover {
  border-color: rgb(240 90 32 / 68%);
}

.contact-card h3,
.contact-link strong {
  color: #f5f7f7;
}

.contact-link {
  border-top-color: #263b3e;
}

.app-footer {
  background: #05070a;
  color: #77858a;
}

.app-footer a:hover {
  color: #f5f7f7;
}

/* 合作方 logo：深色下反成白色单色，卡片是半透明的白 */
.app-footer__partner {
  border-color: rgb(255 255 255 / 9%);
  background: rgb(255 255 255 / 5%);
  color: #c3cbcb;
  box-shadow: inset 0 1px 0 rgb(255 255 255 / 4%);
}

.app-footer__partner:hover {
  border-color: rgb(255 255 255 / 16%);
  background: rgb(255 255 255 / 9%);
}

.app-footer__partner img {
  opacity: 0.78;
  filter: brightness(0) invert(1);
}

.app-footer__partner:hover img {
  opacity: 1;
}

.app-footer__filings strong {
  color: #a8b7bb;
}

.status-screen {
  background: #040509;
  color: #f5f7f7;
}

.status-screen__spinner {
  border-color: #263b3e;
  border-top-color: #f05a20;
}

.status-screen--error button {
  background: #f05a20;
  color: #ffffff;
}

/* About page */

.about-shell,
.about-page,
.about-content {
  background: #040509;
}

.about-hero {
  background-color: #f05a20;
  background-image:
    linear-gradient(45deg, rgb(255 255 255 / 10%) 25%, transparent 25%),
    linear-gradient(-45deg, rgb(255 255 255 / 10%) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgb(255 255 255 / 10%) 75%),
    linear-gradient(-45deg, transparent 75%, rgb(255 255 255 / 10%) 75%);
}

.about-hero::after {
  position: absolute;
  z-index: -1;
  inset: 0;
  background: radial-gradient(circle at 82% 40%, rgb(255 197 99 / 24%), transparent 34%);
  content: "";
  pointer-events: none;
}

.about-hero__reference {
  opacity: 1;
  clip-path: none;
  filter: none;
  mix-blend-mode: normal;
  -webkit-mask-image: none;
  mask-image: none;
}

.about-hero h1 {
  color: #f5f7f7;
  text-shadow: 0 0.08em 0.24em rgb(0 0 0 / 35%);
}

.about-hero h1 span:last-child {
  color: #ffffff;
}

.about-block > h2,
.about-member__header h3,
.about-job-card h3 {
  color: #f5f7f7;
}

.about-prose,
.about-member__header p,
.about-team__summary,
.about-why .about-prose {
  color: #98a5aa;
}

.about-member__bio {
  color: #d8dedf;
}

.about-member__header > img {
  background: #142225;
}

.about-timeline__date {
  background: #582d00;
  color: #f1e2d1;
}

.about-timeline__item--ongoing .about-timeline__date {
  background: #424e4e;
  color: #c3cbcb;
}

.about-timeline__stem,
.about-timeline__stem::after {
  background: #7a4210;
}

.about-timeline__label strong {
  color: #f2f2f2;
}

.about-timeline__label small {
  color: #9aa3a6;
}

.about-join {
  background: #0b1519;
}

.about-join__title > span {
  color: #718085;
}

.about-join__title h2 {
  color: #f5f7f7;
}

.about-job-card {
  background: #142225;
}

.about-job-card__icon {
  background: #203034;
}

.about-job-card button,
.about-job-card button:hover {
  background: #283235;
  color: #f5f7f7;
}

/* Coming soon modal */

.coming-soon {
  background: #040509;
}

.coming-soon__backdrop {
  background: rgb(0 0 0 / 68%);
}

.coming-soon__card {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 8px 8px 0 #020304;
}

.coming-soon__close {
  color: #f5f7f7;
}

.coming-soon__close:hover {
  background: #283235;
}

.coming-soon__bubble,
.coming-soon__badge,
.coming-soon__countdown strong,
.coming-soon__form-wrap input,
.coming-soon__form-wrap button,
.coming-soon__success {
  border-color: #020304;
}

.coming-soon__bubble--yellow,
.coming-soon__badge,
.coming-soon__countdown > div:nth-child(1) strong,
.coming-soon__countdown > div:nth-child(4) strong {
  background: #f05a20;
}

.coming-soon__bubble--red,
.coming-soon__countdown > div:nth-child(3) strong,
.coming-soon__success {
  background: #10b56c;
}

.coming-soon__badge,
.coming-soon__title,
.coming-soon__countdown strong,
.coming-soon__success,
.coming-soon__socials {
  color: #f5f7f7;
}

.coming-soon__title span {
  color: #f05a20;
}

.coming-soon__subtitle {
  color: #98a5aa;
}

.coming-soon__countdown strong {
  background: #203034;
  box-shadow: 4px 4px 0 #020304;
}

.coming-soon__countdown span {
  background: #142225;
  color: #d8dedf;
}

.coming-soon__form-wrap input {
  background: #0b1519;
  color: #f5f7f7;
}

.coming-soon__form-wrap input::placeholder {
  color: #718085;
}

.coming-soon__form-wrap input:focus {
  background: #203034;
}

.coming-soon__form-wrap button {
  background: #f05a20;
  box-shadow: 4px 4px 0 #020304;
}

.coming-soon__form-wrap button:hover {
  box-shadow: 6px 6px 0 #020304;
}

@media (max-width: 720px) {
  .coming-soon__card {
    box-shadow: 6px 6px 0 #020304;
  }
}

/*
 * About styles are emitted after the shared theme by Vite. The scoped
 * selectors below deliberately add one level of specificity so this preview
 * remains color-only and does not depend on stylesheet emission order.
 */

html .about-shell,
html .about-shell .about-page,
html .about-shell .about-content {
  background: #040509;
}

html .about-shell .about-hero {
  background-color: #f05a20;
  background-image:
    linear-gradient(45deg, rgb(255 255 255 / 10%) 25%, transparent 25%),
    linear-gradient(-45deg, rgb(255 255 255 / 10%) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgb(255 255 255 / 10%) 75%),
    linear-gradient(-45deg, transparent 75%, rgb(255 255 255 / 10%) 75%);
}

html .about-shell .about-hero::after {
  background: radial-gradient(circle at 82% 40%, rgb(255 197 99 / 24%), transparent 34%);
}

html .about-shell .about-hero__reference {
  opacity: 1;
  clip-path: none;
  filter: none;
  mix-blend-mode: normal;
  -webkit-mask-image: none;
  mask-image: none;
}

html .about-shell .about-hero h1 {
  color: #f5f7f7;
  text-shadow: 0 0.08em 0.24em rgb(0 0 0 / 35%);
}

html .about-shell .about-hero h1 span:last-child {
  color: #ffffff;
}

html .about-shell .about-block > h2,
html .about-shell .about-member__header h3,
html .about-shell .about-job-card h3 {
  color: #f5f7f7;
}

html .about-shell .about-prose,
html .about-shell .about-member__header p,
html .about-shell .about-team__summary,
html .about-shell .about-why .about-prose {
  color: #98a5aa;
}

html .about-shell .about-member__bio {
  color: #d8dedf;
}

html .about-shell .about-member__header > img {
  background: #142225;
}

html .about-shell .about-timeline__date {
  background: #582d00;
  color: #f1e2d1;
}

html .about-shell .about-timeline__item--ongoing .about-timeline__date {
  background: #424e4e;
  color: #c3cbcb;
}

html .about-shell .about-timeline__stem,
html .about-shell .about-timeline__stem::after {
  background: #7a4210;
}

html .about-shell .about-timeline__label strong {
  color: #f2f2f2;
}

html .about-shell .about-timeline__label small {
  color: #9aa3a6;
}

html .about-shell .about-join {
  background: #0b1519;
}

html .about-shell .about-join__title > span {
  color: #718085;
}

html .about-shell .about-join__title h2 {
  color: #f5f7f7;
}

html .about-shell .about-job-card {
  background: #142225;
}

html .about-shell .about-job-card__icon {
  background: #203034;
}

html .about-shell .about-job-card button,
html .about-shell .about-job-card button:hover {
  background: #283235;
  color: #f5f7f7;
}

html body .coming-soon {
  background: #040509;
}

html body .coming-soon__backdrop {
  background: rgb(0 0 0 / 68%);
}

html body .coming-soon__card {
  border-color: #263b3e;
  background: #142225;
  box-shadow: 8px 8px 0 #020304;
}

html body .coming-soon__close {
  color: #f5f7f7;
}

html body .coming-soon__close:hover {
  background: #283235;
}

html body .coming-soon__bubble,
html body .coming-soon__badge,
html body .coming-soon__countdown strong,
html body .coming-soon__form-wrap input,
html body .coming-soon__form-wrap button,
html body .coming-soon__success {
  border-color: #020304;
}

html body .coming-soon__bubble--yellow,
html body .coming-soon__badge,
html body .coming-soon__countdown > div:nth-child(1) strong,
html body .coming-soon__countdown > div:nth-child(4) strong {
  background: #f05a20;
}

html body .coming-soon__bubble--red,
html body .coming-soon__countdown > div:nth-child(3) strong,
html body .coming-soon__success {
  background: #10b56c;
}

html body .coming-soon__badge,
html body .coming-soon__title,
html body .coming-soon__countdown strong,
html body .coming-soon__success,
html body .coming-soon__socials {
  color: #f5f7f7;
}

html body .coming-soon__title span {
  color: #f05a20;
}

html body .coming-soon__subtitle {
  color: #98a5aa;
}

html body .coming-soon__countdown strong {
  background: #203034;
  box-shadow: 4px 4px 0 #020304;
}

html body .coming-soon__countdown > div:nth-child(1) strong,
html body .coming-soon__countdown > div:nth-child(4) strong {
  background: #f05a20;
}

html body .coming-soon__countdown > div:nth-child(3) strong {
  background: #10b56c;
}

html body .coming-soon__countdown span {
  background: #142225;
  color: #d8dedf;
}

html body .coming-soon__form-wrap input {
  background: #0b1519;
  color: #f5f7f7;
}

html body .coming-soon__form-wrap input::placeholder {
  color: #718085;
}

html body .coming-soon__form-wrap input:focus {
  background: #203034;
}

html body .coming-soon__form-wrap button {
  background: #f05a20;
  box-shadow: 4px 4px 0 #020304;
}

html body .coming-soon__success {
  background: #10b56c;
}

@media (max-width: 720px) {
  html body .coming-soon__card {
    box-shadow: 6px 6px 0 #020304;
  }
}
